import {
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRoute = createRouteRef();

export const registerComponentRouteRef = createExternalRouteRef();

export const catalogEntityRouteRef = createRouteRef({
  params: ['namespace', 'kind', 'name'],
});

export const catalogIndexRouteRef = createExternalRouteRef();

export const createComponentRouteRef = createExternalRouteRef();

export const userSettingsRouteRef = createExternalRouteRef();
